import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { Store } from '@ngrx/store';
import { map, take, switchMap, filter, timeout, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { AppState } from '../store/app.state';
import { AuthService } from '../services/auth.service';
import { selectIsAuthenticated, selectLoading } from '../store/auth/auth.selectors';
import * as AuthActions from '../store/auth/auth.actions';

export const authGuard: CanActivateFn = () => {
  const store = inject(Store<AppState>);
  const router = inject(Router);
  const authService = inject(AuthService);

  return store.select(selectIsAuthenticated).pipe(
    take(1),
    switchMap((isAuthenticated) => {
      if (isAuthenticated) {
        return of(true);
      }

      // Se non autenticato ma c'è un token, prova a caricare l'utente
      const token = authService.getToken();
      if (token) {
        store.dispatch(AuthActions.loadUser());
        // Aspetta che il loading finisca e controlla se è autenticato
        return store.select(selectLoading).pipe(
          filter((loading) => !loading), // Aspetta che il loading finisca
          take(1),
          switchMap(() => store.select(selectIsAuthenticated).pipe(take(1))),
          timeout(5000), // Timeout di 5 secondi
          map((auth) => {
            if (!auth) {
              router.navigate(['/login']);
              return false;
            }
            return true;
          }),
          catchError(() => {
            router.navigate(['/login']);
            return of(false);
          })
        );
      }

      router.navigate(['/login']);
      return of(false);
    })
  );
};
